import axios from 'axios';

import { headers, AUTH_SERVICE_URL } from '../../config';

export function getStockJournalPermissions() {
    return axios.get(`${AUTH_SERVICE_URL}/stock-journal`, { headers: headers() })
}

export function getStockPermissions() {
    return axios.get(`${AUTH_SERVICE_URL}/warehouse`, { headers: headers() })
}

export function fetchUserPermissions() {
    return axios.get(`${AUTH_SERVICE_URL}/user-permissions`, { headers: headers()})
}